import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DoreCalculator = () => {
  const [weight, setWeight] = useState("25");
  const [purity, setPurity] = useState("95.89");
  const [payable, setPayable] = useState("92");
  const [spot, setSpot] = useState("");
  const [spotLive, setSpotLive] = useState(false);

  useEffect(() => {
    fetch(`${API}/market/gold`)
      .then((r) => r.json())
      .then((d) => { setSpot(String(d.price)); setSpotLive(true); })
      .catch(() => setSpot("4300"));
  }, []);

  const num = (s) => parseFloat(s) || 0;
  const fineOz = num(weight) * (num(purity) / 100) * 32.1507;
  const payableOz = fineOz * (num(payable) / 100);
  const value = payableOz * num(spot);
  const usd = (n) => n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

  const inputCls = "w-full bg-[#0A0A0B] card-line px-4 py-3 text-sm text-zinc-200 font-mono2 tabular-nums focus:outline-none focus:border-[#C9A227]/60 transition-colors";
  const labelCls = "block font-mono2 text-[10px] uppercase tracking-[0.22em] text-zinc-400 mb-2";

  return (
    <div data-testid="dore-calculator" className="card-line bg-[#121215] p-7">
      <div className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#C9A227] mb-6">Doré Net-Value Estimator</div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className={labelCls} htmlFor="calc-weight">Gross weight (kg)</label>
          <input id="calc-weight" data-testid="calc-weight" value={weight} onChange={(e) => setWeight(e.target.value)} inputMode="decimal" className={inputCls} />
        </div>
        <div>
          <label className={labelCls} htmlFor="calc-purity">XRF purity (%)</label>
          <input id="calc-purity" data-testid="calc-purity" value={purity} onChange={(e) => setPurity(e.target.value)} inputMode="decimal" className={inputCls} />
        </div>
        <div>
          <label className={labelCls} htmlFor="calc-payable">Payable rate (%)</label>
          <input id="calc-payable" data-testid="calc-payable" value={payable} onChange={(e) => setPayable(e.target.value)} inputMode="decimal" className={inputCls} />
        </div>
        <div>
          <label className={labelCls} htmlFor="calc-spot">Spot ($/oz){spotLive ? " · live" : ""}</label>
          <input id="calc-spot" data-testid="calc-spot" value={spot} onChange={(e) => { setSpot(e.target.value); setSpotLive(false); }} inputMode="decimal" className={inputCls} />
        </div>
      </div>
      <div className="mt-6 pt-6 hairline-t space-y-2 font-mono2 text-[12px] tabular-nums">
        <div className="flex justify-between text-zinc-400">
          <span>Fine gold content</span><span data-testid="calc-fine-oz">{fineOz.toFixed(2)} oz</span>
        </div>
        <div className="flex justify-between text-zinc-400">
          <span>Payable ounces</span><span data-testid="calc-payable-oz">{payableOz.toFixed(2)} oz</span>
        </div>
        <div className="flex justify-between items-baseline pt-3">
          <span className="uppercase tracking-[0.2em] text-[#C9A227] text-[11px]">Estimated net value</span>
          <span className="text-3xl gold-text font-medium" data-testid="calc-net-value">{usd(value)}</span>
        </div>
      </div>
      <p className="mt-4 text-[11px] text-zinc-600 leading-relaxed">
        Indicative only. Final settlement follows the destination refinery fire assay and the agreed instrument terms.
      </p>
    </div>
  );
};
